export default function defer() {
  let res, rej;
  const $promise = new Promise((_res, _rej) => {
    res = _res;
    rej = _rej;
  });
  return [$promise, res, rej];
}



// WEBPACK FOOTER //
// ./src/utils/defer.js